import { DataBean } from "../../DataBean";


export class HealthTechnologyPurpose extends DataBean {


    public async getHealthTechnologyPurposeCatalog(idState:any,regexStr:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getHealthTechnologyPurposeCatalog_Number_String_Number_Number", [idState,regexStr,page,recordsPerPage]);
    }


}